import { render, staticRenderFns } from "./titleCleaning.vue?vue&type=template&id=bd1baaae&scoped=true"
import script from "./titleCleaning.vue?vue&type=script&lang=js"
export * from "./titleCleaning.vue?vue&type=script&lang=js"
import style0 from "./titleCleaning.vue?vue&type=style&index=0&id=bd1baaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1baaae",
  null
  
)

export default component.exports